import React, { useState } from 'react';
import ButtonCmp from 'src/components/ButtonCmp';

import AgentMessageCard from './CommonComponents/AgentMessageCard';

export interface IShipmentReviewFields {
    serviceType: string;
    items: string;
    origin: string;
    destination: string;
    pickup: string;
    equipment: string;
}

interface IProps {
    fields: IShipmentReviewFields;
    onMakeChanges: () => void;
    onCreateShipment: () => void;
}

const ShipmentReviewCard = ({ fields, onMakeChanges, onCreateShipment }: IProps) => {
    const [isCreating, setIsCreating] = useState(false);

    const handleCreateShipment = () => {
        if (isCreating) return;
        setIsCreating(true);
        onCreateShipment();
    };

    return (
        <AgentMessageCard senderType="ai" className="!max-w-full !pr-0 shadow-xs" contentClassName="!p-0 !space-y-0">
            <p className="px-3 py-3 border-b border-utilityGray200 rounded-t-lg bg-gray50 text-grayLight900 text-xs leading-[1.5] font-semibold">New Shipment - review &amp; confirm</p>

            <div className="grid grid-cols-2 gap-y-3 gap-x-3 px-3 py-3 bg-white">
                <div>
                    <p className="text-gray500 text-xs leading-[1.5]">Service Type</p>
                    <p className="text-textSecondary text-xs leading-[1.5] font-medium">{fields.serviceType}</p>
                </div>
                <div>
                    <p className="text-gray500 text-xs leading-[1.5]">Items</p>
                    <p className="text-textSecondary text-xs leading-[1.5] font-medium">{fields.items}</p>
                </div>
                <div>
                    <p className="text-gray500 text-xs leading-[1.5]">Origin</p>
                    <p className="text-textSecondary text-xs leading-[1.5] font-medium">{fields.origin}</p>
                </div>
                <div>
                    <p className="text-gray500 text-xs leading-[1.5]">Destination</p>
                    <p className="text-textSecondary text-xs leading-[1.5] font-medium">{fields.destination}</p>
                </div>
                <div>
                    <p className="text-gray500 text-xs leading-[1.5]">Pickup</p>
                    <p className="text-textSecondary text-xs leading-[1.5] font-medium">{fields.pickup}</p>
                </div>
                <div>
                    <p className="text-gray500 text-xs leading-[1.5]">Equipment</p>
                    <p className="text-textSecondary text-xs leading-[1.5] font-medium">{fields.equipment}</p>
                </div>
            </div>

            <div className="px-3 py-3 border-t border-utilityGray200 bg-white rounded-b-lg flex items-center justify-between">
                <ButtonCmp type="button" size="none" className="!shadow-none !bg-transparent !border-0 text-grayLight600 text-xs font-medium" onClick={onMakeChanges} disabled={isCreating}>
                    Make Changes
                </ButtonCmp>
                <ButtonCmp type="button" size="none" className="!shadow-none !bg-transparent !border-0 text-primary text-xs font-semibold" onClick={handleCreateShipment} disabled={isCreating}>
                    Create Shipment
                </ButtonCmp>
            </div>
        </AgentMessageCard>
    );
};

export default ShipmentReviewCard;
